import ApiKeys from "./ApiKeys";

export default function AccessControl() {
  return <ApiKeys />;
}
